import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_GZ_DASHBOARD_TITLE_WITH_FEED_BACK_TOOLBAR } from '../../../webcomponents.constants';
import { translateFn } from '../../../utils/translator.helper';
import { DisplayMode, FontSizes, FontWeights } from 'apps/webcomponents/src/types/common/types';
import { ButtonTypes } from 'apps/webcomponents/src/ui/gzButton/types';

@customElement(WEB_COMPONENT_GZ_DASHBOARD_TITLE_WITH_FEED_BACK_TOOLBAR)
export class GzDashboardTitleWithFeedBackToolbarWebComponent extends LitElement {
  @property({ type: Boolean, attribute: true, reflect: true })
  isEarlyAccess = false;

  @property({type: Boolean, attribute: true, reflect: true})
  showFeedbackFormBtn = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  hideFeedbackButton = false;

  @property({ type: String, attribute: true, reflect: true })
  title = '';

  @property({ type: String, attribute: true, reflect: true })
  displayMode: DisplayMode;

  @property({ type: String, attribute: true, reflect: true })
  companyName = '';

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    return html`
      <div class="d-flex align-items-center justify-space-between">
        <div class="title-container d-flex flex-row align-items-center">
          <gz-title fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}">${this.title}</gz-title>
          ${this.renderCompanyName()} ${this.renderEarlyAccess()}
        </div>
        ${this.renderFeedBackButton()} ${this.renderLogo()}
      </div>
    `;
  }

  private renderEarlyAccess(): TemplateResult | undefined {
    if (!this.isEarlyAccess) {
      return;
    }

    switch (this.displayMode) {
      case DisplayMode.DASHBOARD:
        return html` <div class="early-access-container">
          <gz-title fontSize="${FontSizes.PARAGRAPH_12}" class="text-uppercase" fontWeight="500">${translateFn('Early Access')}</gz-title>
        </div>`;
      case DisplayMode.PDF:
      case DisplayMode.REPORT:
        return;
      default:
        return;
    }
  }

  private renderFeedBackButton(): TemplateResult | undefined {
    if ((!this.isEarlyAccess && !this.showFeedbackFormBtn) || this.hideFeedbackButton) {
      return;
    }

    switch (this.displayMode) {
      case DisplayMode.DASHBOARD:
        return html`<gz-button
            @click="${this.handleFeedBackBtn}"
            class="feedback-btn"
            type="${ButtonTypes.QUIET}"
            fontSize="${FontSizes.HEADING_6}"
          ><span class="icon ds-icon-feedback_notes"></span><span>${translateFn('Feedback')}</span></gz-button
        >`;
      case DisplayMode.PDF:
      case DisplayMode.REPORT:
        return;
      default:
        return;
    }
  }

  private renderLogo(): TemplateResult | undefined {
    switch (this.displayMode) {
      case DisplayMode.PDF:
        return html`<div class="company-logo is-default" hidden>
          <img src="app/webcomponents/assets/images/bd_logo.svg" width="200" height="25"></div>`;
      default:
        return;
    }
  }

  private renderCompanyName(): TemplateResult | undefined {
    switch (this.displayMode) {
      case DisplayMode.PDF:
        return html`<gz-text class="company-name">${this.companyName}</gz-text>`;
      default:
        return;
    }
  }

  private handleFeedBackBtn(): void {
    const newEvent = new CustomEvent('feedbackPopupOpen', {
      detail: {},
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(newEvent);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-dashboard-title-with-feedback-toolbar': GzDashboardTitleWithFeedBackToolbarWebComponent;
  }
}
